import { getDataFromSessionStorage } from "../../config/configHelper";
import { logError } from "../../library/logging/loggingService";
export const APP_CONFIG_KEYS = {
    POST_SALES_SELLER_LINK: "postSalesSellerLink",
    ABS_COPILOT_LINK: "absCopilotLink",
};
const POST_SALES_TILE = "Post Sales Seller Support Team (PSSST)";
const ABS_COPILOT_TILE = "ABS Copilot Compete Escalations";
/**
 * Retrieves a configured URL from Azure App Configuration via session storage.
 * Logs an error to Application Insights if the URL is not configured.
 */
export const getConfiguredLink = (key, tileName) => {
    const configLink = getDataFromSessionStorage(key);
    if (!configLink) {
        logError(`Failed to load ${key} URL from configuration`, {
            component: "Escalations",
            action: "ConfiguredLinkMissing",
            configKey: key,
            tile: tileName,
            feature: "TileRedirect",
        });
    }
    return configLink;
};
export const getPostSalesSellerLink = () => getConfiguredLink(APP_CONFIG_KEYS.POST_SALES_SELLER_LINK, POST_SALES_TILE);
export const getAbsCopilotLink = () => getConfiguredLink(APP_CONFIG_KEYS.ABS_COPILOT_LINK, ABS_COPILOT_TILE);
